import React from "react";

const Approach = () => {
  return (
    <div className="bg-black py-10 sm:py-20 lg:py-20">
      <div className="max-w-6xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-16 sm:mb-20">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-400 mb-4">
            Philosophy
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin">
            Our <em className="text-gray-300">Approach</em>
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Item 1 */}
          <div className="text-center">
            <div className="w-px h-16 sm:h-20 bg-gradient-to-b from-transparent via-white to-transparent mx-auto mb-6 sm:mb-8"></div>
            <h3 className="text-lg sm:text-xl font-light mb-4 tracking-wide">
              Practical Solutions
            </h3>
            <p className="text-gray-400 leading-relaxed font-light text-sm sm:text-sm">
              Designed for modern professionals and organizations navigating fast-paced change.
            </p>
          </div>

          {/* Item 2 */}
          <div className="text-center">
            <div className="w-px h-16 sm:h-20 bg-gradient-to-b from-transparent via-white to-transparent mx-auto mb-6 sm:mb-8"></div>
            <h3 className="text-lg sm:text-xl font-light mb-4 tracking-wide">
              Hands-on Training
            </h3>
            <p className="text-gray-400 leading-relaxed font-light text-sm sm:text-sm">
              Learning through guided practice and mentorship for scalable, sustainable growth.
            </p>
          </div>

          {/* Item 3 */}
          <div className="text-center">
            <div className="w-px h-16 sm:h-20 bg-gradient-to-b from-transparent via-white to-transparent mx-auto mb-6 sm:mb-8"></div>
            <h3 className="text-lg sm:text-xl font-light mb-4 tracking-wide">
              Evidence-based
            </h3>
            <p className="text-gray-400 leading-relaxed font-light text-sm sm:text-sm">
              Built on research, real-world data, and proven best practices in AI adoption.
            </p>
          </div>

          {/* Item 4 */}
          <div className="text-center">
            <div className="w-px h-16 sm:h-20 bg-gradient-to-b from-transparent via-white to-transparent mx-auto mb-6 sm:mb-8"></div>
            <h3 className="text-lg sm:text-xl font-light mb-4 tracking-wide">
              Multi-sector
            </h3>
            <p className="text-gray-400 leading-relaxed font-light text-sm sm:text-sm">
              Working across industries from business to tech to drive practical transformation.
            </p>
          </div>

          {/* Item 5 */}
          <div className="text-center">
            <div className="w-px h-16 sm:h-20 bg-gradient-to-b from-transparent via-white to-transparent mx-auto mb-6 sm:mb-8"></div>
            <h3 className="text-lg sm:text-xl font-light mb-4 tracking-wide">
              Global Insights
            </h3>
            <p className="text-gray-400 leading-relaxed font-light text-sm sm:text-sm">
              Global perspectives paired with contextual understanding for future ready skills.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Approach;
